import z from "zod";
import { DocumentMetaTs, ImageTs, LocaleTs } from "../../common";


//newsletter-capture-card
export type NewsletterCaptureCard = z.output<typeof NewsletterCaptureCardSchema>;
export const NewsletterCaptureCardSchema = z.object({
  title: z.string(),
  message: z.string(),
  inputPlaceholder: z.string(),
  inputInformation: z.string(),
  cta: z.string(),
  emailValidationError: z.string(),
  successConfirmationMessage: z.string(),
  thanks: z.string(),
  // success: z.string()
});

//meta
export type Meta = z.output<typeof MetaSchema>;
export const MetaSchema = z.object({
  pageTitle: z.string(),
  pageDescription: z.string(),
  ogImage: ImageTs.optional().nullable(),
  ogType: z.string().optional().nullable(),
});

//this schema is use to fetch only the metadata of page and avoid overfetching
//page metadata
export type PageMetaData = z.output<typeof PageMetaDataSchema>;
export const PageMetaDataSchema = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,

  // localizations: z.array(DocumentMetaTs),
  metaData: MetaSchema
})


//blog-card
export type BlogCard = z.output<typeof BlogCardSchema>;
export const BlogCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  picture: ImageTs,
  cta: z.string(),
});

//faq-question
export type FaqQuestion = z.output<typeof FaqQuestionSchema>;
export const FaqQuestionSchema = z.object({
  question: z.string(),
  response: z.string().optional().nullable(),
  articleLink: z.string().optional().nullable(),

});
//faq
export type Faq = z.output<typeof FaqSchema>;
export const FaqSchema = z.object({
  categoryTitle: z.string(),
  title: z.string(),
  questions: FaqQuestionSchema.array(),
  showMoreCta: z.string(),
  categoryLabel: z.string(),
});

//faq-hero
export type FaqHero = z.output<typeof FaqHeroSchema>;
export const FaqHeroSchema = z.object({
  tagLine: z.string(),
  travelersTabLabel: z.string(),
  retailersTabLabel: z.string(),
  categoryListTitle: z.string(),
});

//language-item TODO check to delete

//support-client-card
export type SupportClientCard = z.output<typeof SupportClientCardSchema>;
export const SupportClientCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  subTitle: z.string(),
  pictures: ImageTs.array(),
  cta: z.string(),

});
export type SharedComponent = SupportClientCard | FaqHero | Faq | FaqQuestion | BlogCard | Meta | NewsletterCaptureCard
